"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var rql_1 = require("../rql");
var currency_1 = require("../currency");
var form_group_with_input_1 = require("../components/form_group_with_input");
var offer_quantity_select_1 = require("./offer_quantity_select");
var user_context_provider_1 = require("../components/user_context_provider");
var user_context_helpers_1 = require("../user_context_helpers");
var constants_1 = require("../constants");
function taxHint(taxable) {
    if (taxable && taxable.taxIncluded) {
        return " (" + taxable.taxIncludedHint + ")";
    }
    return '';
}
function priceLabel(action, taxable) {
    if (action === rql_1.core_apimessages_NegotiationAction.COUNTER) {
        return "" + I18n.t('commons.offers.label.counterPrice') + taxHint(taxable);
    }
    return "" + I18n.t('commons.offers.label.initialPrice') + taxHint(taxable);
}
function shippingPriceForBuyer(props) {
    if (props.party === rql_1.core_apimessages_NegotiationParty.BUYER) {
        var shippingPrice = lodash_1.get(props, 'offer.shippingPrice', '');
        return I18n.t('commons.offers.shippingPrice', { shippingPrice: shippingPrice });
    }
}
function moreThanOneInventoriedItem(listing) {
    return listing.hasInventory && listing.inventory > 1;
}
function userShouldSeeQuantitySelect(party, user, lastOfferedQuantity) {
    return lastOfferedQuantity > 1 ||
        (party === rql_1.core_apimessages_NegotiationParty.SELLER && user_context_helpers_1.isExperimentEnabled(user, constants_1.experiments.OFFER_QUANTITY));
}
function displayQuantitySelect(props) {
    var action = props.action, listing = props.listing, party = props.party, user = props.user, offer = props.offer;
    return (action === rql_1.core_apimessages_NegotiationAction.COUNTER || action === rql_1.core_apimessages_NegotiationAction.CREATE) &&
        moreThanOneInventoriedItem(listing) &&
        userShouldSeeQuantitySelect(party, user, offer.quantity);
}
function OfferAmountInputs(props) {
    var _a = lodash_1.defaults(currency_1.default.get(props.currency), { symbol: '', displayCode: '' }), symbol = _a.symbol, displayCode = _a.displayCode;
    var shippingPrice = shippingPriceForBuyer(props);
    return (React.createElement("div", { className: "offers-form__price-row" },
        React.createElement("div", { className: "offers-form__price" },
            React.createElement(form_group_with_input_1.default, { label: priceLabel(props.action, props.taxable), currencyPrefix: symbol, currencySuffix: [displayCode, shippingPrice].join(' ').trim(), inputName: "offer-price", fieldName: "price", value: props.offer.price, updateField: props.onOfferChange, autoFocus: props.autoFocus, numberOnly: true, required: true })),
        displayQuantitySelect(props) &&
            React.createElement("div", { className: "offers-form__qty" },
                React.createElement(offer_quantity_select_1.default, { inventory: props.listing.inventory, party: props.party, quantity: props.offer.quantity, onQuantityChange: props.onOfferChange }))));
}
exports.default = user_context_provider_1.withUserContext(OfferAmountInputs);
//# sourceMappingURL=offer_amount_inputs.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_amount_inputs.js
// module id = Iy6T
// module chunks = 20 21